import { Component } from '@angular/core';

import { AccountService } from './_services';
import { Account, Role } from './_models';

@Component({ selector: 'app', templateUrl: 'app.component.html', styleUrls: ['app.component.css'] })
export class AppComponent {
    Role = Role;
    account: Account;

    constructor(private accountService: AccountService) {
        this.accountService.account.subscribe(x => this.account = x);
        // console.log('account')
        // console.log(this.account);
    }
    isDropdownOpen = false;

    toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    }

    logout() {
        this.accountService.logout();
    }
}